import { API_RESERVED_NICKNAMES } from './EsConstants';
import { esRead } from './EsFetch';

/**
 * The reserved nicknames and the sentence refusing one, read from esback (EsNicknames) the
 * first time a form is submitted, so it can say so on the field before it posts. esback
 * refuses the same list whatever this says; a failed read only means the server says it.
 */
let mReserved = null;

function loadReserved() {
    if ( !mReserved ) {
        mReserved = esRead( API_RESERVED_NICKNAMES )
            .then( ( pBody ) => ( {
                reserved: Array.isArray( pBody?.reserved ) ? pBody.reserved : [],
                msg: pBody?.msg ?? '',
            } ) )
            .catch( () => ( { reserved: [], msg: '' } ) );
    }
    return mReserved;
}

/** For a test: the next form asks esback again. */
export function resetReservedNicknames() {
    mReserved = null;
}

/** The refusal for this nickname, or null: trimmed and case-folded, as esback compares. */
export function reservedNicknameError( pNickname, pRule ) {
    if ( !pRule || !pNickname ) return null;
    return pRule.reserved.includes( pNickname.trim().toLowerCase() ) ? pRule.msg : null;
}

/** How a gone author is signed, as esback signs a comment (EsNicknames.DELETED). */
export const ES_DELETED = '<deleted>';

/**
 * An author as every byline shows one, <name>; a gone author (null, or esback's own mark) is
 * <deleted>. An author without maker privileges is {name}; only an explicit false says so, so a
 * byline that never learned (a comment) stays <name>.
 */
export function esAuthorTag( pName, pMaker = true ) {
    if ( !pName || pName === ES_DELETED ) return ES_DELETED;
    return pMaker === false ? '{' + pName + '}' : '<' + pName + '>';
}

/** What a form about to post this nickname should say instead, or null to go ahead. */
export async function reservedNicknameRefusal( pNickname ) {
    return reservedNicknameError( pNickname, await loadReserved() );
}
